import * as S from "./MktLandingPageMarketersOrganism.style";
import { marketersData } from "../../../../models/landing/marketers/marketer.model";
import Image from "next/legacy/image";

export default function MktLandingPageMarketersOrganism() {
  return (
    <S.Wrapper>
      <S.Title>
        그로스 마케팅 역량으로
        <br />
        꿈꾸던 마케터로의 삶을 시작하세요.
      </S.Title>
      <S.Content>
        {marketersData.map((marketer) => (
          <S.Marketer key={marketer.title}>
            <Image
              src={marketer.img}
              alt="marketer-img"
              width={80}
              height={80}
            />
            <S.MarketerTitle>{marketer.title}</S.MarketerTitle>
            <S.MarketerDesc>{marketer.desc}</S.MarketerDesc>
          </S.Marketer>
        ))}
      </S.Content>
    </S.Wrapper>
  );
}
